var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('downloadExcel',{attrs:{"data":_vm.dataForExcel}},[_c('button',[_vm._v("Excel")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }